import { useHttp } from '@/shared/lib'
import { computed, type Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'

/**
 * Функция поиска элемента на карте
 */
export const useLoadDependenciesCircleObjects = (objectId: Ref<number>, data: Ref<any>) => {
  const http = useHttp()

  const url = computed(() => {
    const searchParams = new URLSearchParams(data.value)
    return `/objects/${objectId.value}/circle?${searchParams}`
  })

  const queryKey = computed(() => ['load_dependencies_circle_objects', objectId, data])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: computed(() => data.value.coords[0] != 0),
  })
}
